import { CreditCardType } from '../Stripe';

const REQ_FIELD = ['id', 'brand', 'exp_month', 'exp_year', 'last4'];

/**
 * @deprecated This export is deprecated and should not be used in new code.
 * Use the equivalent from application-types instead.
 */
export default function isStripeCreditCard<T>(
  paymentMethod: T | CreditCardType
): paymentMethod is CreditCardType {
  return (
    !!paymentMethod &&
    REQ_FIELD.every(
      field => (paymentMethod as { [key: string]: any })[field] !== undefined
    )
  );
}
